const marketplaces = [
  ["Barrie, Mapleview", "barrie-mapleview"],
  ["Toronto, North York", "toronto-north-york"]
];

export default marketplaces;
